<template>
  <CVButton variant="default" class="max-sm:w-full" :disabled="disabled" :is-loading="isLoading">
    <slot></slot>
    <ArrowRightIcon class="h-5 w-5" />
  </CVButton>
</template>
<script setup lang="ts">
import { ArrowRightIcon } from '@heroicons/vue/24/solid';

defineProps<{
  disabled?: boolean;
  isLoading?: boolean;
}>();
</script>
